// Binds the in-flight job id to ?job= in the URL — component state alone lost
// a running job's progress on refresh.
import { useNavigate, useSearch } from '@tanstack/react-router';
import { UpdatesHub } from './UpdatesHub';

export function UpdatesRoute() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { job?: string };
  return (
    <UpdatesHub
      jobId={search.job ?? null}
      onJobChange={(job) => void navigate({ to: '/updates', search: job ? { job } : {} })}
    />
  );
}
